import { render, staticRenderFns } from "./CalculationTester.vue?vue&type=template&id=63f1e318"
import script from "./CalculationTester.vue?vue&type=script&lang=js"
export * from "./CalculationTester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports